import { ICON_SELECTOR } from '@ardoq/icons';
import { css } from 'styled-components';
import { DropdownItemColorMap, DropdownItemStateColorMap } from './types';

const composeCssColorBlock = ({
  color,
  backgroundColor,
  iconColor,
}: DropdownItemStateColorMap) => css`
  ${color &&
  css`
    color: ${color};
  `};
  ${backgroundColor &&
  css`
    background-color: ${backgroundColor};
  `}
  ${(iconColor || color) &&
  css`
    ${ICON_SELECTOR} {
      color: ${iconColor || color};
    }
  `}
`;

export const composeCssStatesColorBlock = (
  colorMap: DropdownItemColorMap
) => css`
  ${composeCssColorBlock(colorMap.default)}
  &:hover {
    ${composeCssColorBlock(colorMap.hover)}
  }
`;
